<template>
  <div v-if="page_loading">
      <loading :page_loading="page_loading" />
  </div>
  <div v-else>
    <loading :loading="loading" />
    <v-card elevation="1" class="v-card-bottom-30">
      <v-card-title style="height: 60px;">
        <h4>{{use_language.finance_1}}</h4> <v-icon>mdi-chevron-right</v-icon> <span class="font-weight-regular body-1" > <a href="wallet" style="text-decoration: none; color: black ;">{{use_language.balance_list}}e</a>  </span><v-icon>mdi-chevron-right</v-icon>  <span class="font-weight-regular body-1"> {{use_language.invoice_information}} </span>

        <v-spacer/>

        <vue-excel-xlsx
          id="GetExcel"
          v-show="false"
          :data="datalist_for_excel"
          :columns="excel_detail_invoice_list_header"
          :file-name="use_language.invoice_data_report"
        >
        </vue-excel-xlsx>
        <v-btn
          v-if="datalist != null && datalist.length > 0 && ch_InvoiceGroupID != null"
          :elevation="1"
          outlined
          color="success"
          class="px-2"
          @click="ExportExcel()"
        >
          <v-icon color="success">mdi-file-excel</v-icon>
          {{use_language.export_excel}}
          <span v-if="loadingExcel != 0">({{ loadingExcel }}%)</span>
        </v-btn>
      </v-card-title>
    </v-card>
    <v-card class="elevation-0 v-card-bottom-30">
      <v-card-title>
        <font v-if="datalist != null && datalist.length > 0">{{use_language.invoice_information}} : {{ sh_invoiceNo }}</font>
        <v-spacer></v-spacer>
        <small>{{use_language.quantity}} : {{format_number(totalRows)}} {{use_language.row}}</small>
       <!-- <font class="hidden-xs-only" v-if="this.datalist.length>0">ข้อมูลใบแจ้งหนี้ : {{ sh_invoiceNo }} (เวลาออกใบเสร็จ {{this.datalist[0]['IV_CreatedDatetime']}})</font>
       <font class="hidden-sm-and-up" v-if="this.datalist.length>0">ข้อมูลใบแจ้งหนี้ : {{ sh_invoiceNo }}<br>(เวลาออกใบเสร็จ {{this.datalist[0]['IV_CreatedDatetime']}})</font> -->
      </v-card-title>
      <v-card-text>
        <!-- PC -->
        <!-- hide-default-footer
        :items-per-page="20000" -->
        <div style="overflow-x : auto;" v-if="ch_InvoiceGroupID != null">
          <v-data-table
            :headers="headers"
            key="id"
            :items="datalist"
            item-key="orderID"
            class="elevation-0 packhai-border-table"
            hide-default-footer
            :items-per-page="9999999999"
            :mobile-breakpoint="0"
            >
            <template v-slot:item.num="{ item }">
              <font v-if="item['orderID'] != 'รวมยอด'">{{ datalist.indexOf(item) + 1 + offsets }}</font>
            </template>
            <template v-slot:item.orderID="{ item }">
              <!-- <v-btn color="primary" text @click="detail_page(item.token)">{{ item['orderID'] }}</v-btn> -->
              <a href="#" v-if="item['orderID'] != 'รวมยอด'" @click="detail_page(item.orderMasterID)"> {{ item['orderID'] }}</a>
              <span v-else>{{ item['orderID'] }}</span>
            </template>
            <template v-slot:item.expressCompanyLogo="{ item }">
              <v-row class="pa-0 ma-0" align="center">
                <v-col class="pa-0 ma-0"  align="center">
                  <v-img :src="item.expressCompanyLogo == null ? '' : item.expressCompanyLogo" width="50" height="auto" ></v-img>
                </v-col>
              </v-row>
            </template>
          </v-data-table>
          <v-row  class="mx-0 mt-5">

            <v-col cols="2" md="3" lg="2" xl="1"/>
            <v-col cols="8" md="6" lg="8" xl="10" align="center">
              <div class="text-center" @click="changePage()">
                <v-pagination
                  v-model="page"
                  :length="pageLength"
                  :total-visible="7"
                  color="primary"
                />
              </div>
            </v-col>
            <v-col cols="2" md="3" lg="2" xl="1" class="text-right">
              <v-select
                v-model="limits"
                :label="use_language.display_amount"
                :items="[10, 20, 50, 100, 500, 1000]"
                @change="LimitChange()"
                outlined
              ></v-select>
            </v-col>

          </v-row>

          <v-row justify="end" v-if="data_group_detail != null">
              <v-col lg="5">
                  <v-row class="py-0">
                      <v-col>
                          {{use_language.freight}}
                      </v-col>
                      <v-col cols="4" lg="3" align="right">
                          <span>{{ data_group_detail.deliveryPrice }}</span>
                      </v-col>
                  </v-row>
                  <v-divider></v-divider>
                  <v-row class="py-0">
                      <v-col>
                          {{use_language.cod_service_fee}}
                      </v-col>
                      <v-col cols="4" lg="3" align="right">
                          <span>{{ data_group_detail.codCharged }}</span>
                      </v-col>
                  </v-row>
                  <!-- <v-divider></v-divider> -->
                  <v-row class="py-0">
                      <v-col>
                          {{use_language.vat}}
                      </v-col>
                      <v-col cols="4" lg="3" align="right">
                          <span>{{ data_group_detail.codVatAmount }}</span>
                      </v-col>
                  </v-row>
                  <v-divider></v-divider>
                  <v-row class="py-0">
                      <v-col>
                          {{use_language.other_service_charges}}
                      </v-col>
                      <v-col cols="4" lg="3" align="right">
                          <span>{{ data_group_detail.servicePrice }}</span>
                      </v-col>
                  </v-row>
                  <!-- <v-divider></v-divider> -->
                  <v-row class="py-0">
                      <v-col>
                          {{use_language.vat}}
                      </v-col>
                      <v-col cols="4" lg="3" align="right">
                          <span>{{ data_group_detail.serviceVatAmount }}</span>
                      </v-col>
                  </v-row>
                  <v-divider></v-divider>
                  <!-- <v-row class="py-0">
                      <v-col>
                          ส่วนลด
                      </v-col>
                      <v-col cols="4" lg="3" align="right">
                          <span>{{ data_group_detail.discount }}</span>
                      </v-col>
                  </v-row> -->
                  <v-row class="py-0 font-weight-bold">
                      <v-col>
                          {{use_language.total_amount_}}
                      </v-col>
                      <v-col cols="4" lg="3" align="right">
                          <span>{{ data_group_detail.totalPrice }}</span>
                      </v-col>
                  </v-row>
                  <v-divider></v-divider>
              </v-col>
          </v-row>
        </div>
        <div class="overflow-y-auto" v-else>
          <v-data-table
            :headers="headers_item"
            :items="item_invoice_list"
            hide-default-footer :items-per-page="10000"
            item-key="id"
            class="elevation-0 packhai-border-table"
            :mobile-breakpoint="0"
            >
            <template v-slot:item.totalPrice="{ item }">
              <font>{{ format_price(item.quantity * item.unitPrice)  }}</font>
            </template>
          </v-data-table>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
  import Loading from '@/website/components/Loading'
  import Swal from "sweetalert2";
  import axios from 'axios'
  import { reportService_dotnet } from '@/website/global'
  import { format_number, format_order_id, format_price, FormatInvoice ,get_languages} from '@/website/global_function'
  import { header_token } from '@/website/backend/token'
  import { finance_language } from "@/website/language/finance_language";

  
  export default {
    components: {
        Loading
    },
    data: () => ({
      page_loading: true,
      loading: false,

      use_language: null,
      set_language: null,


        datalist: [],
        datalist_for_excel:[],
        data_group_detail: null,
        sh_invoiceNo: null,
        sh_invoiceDate : null,
        ch_InvoiceGroupID: null,
        item_invoice_list: [],

        // paginations
        page: 1,
        page_tmp: null,
        limits: 10,
        offsets: 0,
        pageLength: null,
        totalRows: 0,

        loadingExcel: 0,
        isNeedSum: true

    }),
    computed: {
      headers () {
        if (this.use_language == null) return []
        return [
          { text: '', align: 'center', value: 'num', sortable: false },
          { text: this.use_language.menu_orders, align: 'center', value: 'orderID', sortable: false },
          { text: this.use_language.track_number, align: 'center', value: 'trackingNo', sortable: false },
          { text: this.use_language.creation_date, align: 'center', value: 'createdDatetime', sortable: false },
          { text: this.use_language.pack_date, align: 'center', value: 'packedDate', sortable: false },
          { text: this.use_language.transport, align: 'center', value: 'expressCompanyLogo', sortable: false },
          // { text: 'ขนส่ง', align: 'center', value: 'expressCompanyName', sortable: false },
          { text: this.use_language.delivery_fee, align: 'right', value: 'deliveryPrice', sortable: false },
          { text: this.use_language.remote_area_fee, align: 'right', value: 'remotePrice', sortable: false },
          { text: this.use_language.cod_value, align: 'right', value: 'codPrice', sortable: false },
          { text: this.use_language.box_fee, align: 'right', value: 'boxPrice', sortable: false },
          { text: this.use_language.pack_fee, align: 'right', value: 'packPrice', sortable: false },
          { text: this.use_language.bubble_fee, align: 'right', value: 'bubblePrice', sortable: false },
          { text: this.use_language.discount, align: 'right', value: 'discount', sortable: false },
          { text: this.use_language.vrich_connection_fee, align: 'right', value: 'vrichFee', sortable: false },
          { text: this.use_language.other_fee, align: 'right', value: 'otherServicePrice', sortable: false },
          { text: this.use_language.total_price, align: 'right', value: 'totalPrice', sortable: false },
        ]
      },
      headers_item () {
        if (this.use_language == null) return []
        return [
          { text: this.use_language.details, align: 'left', value: 'description', sortable: false },
          { text: this.use_language.quantity, align: 'right', value: 'quantity', sortable: false },
          { text: this.use_language.unit_price, align: 'right', value: 'unitPrice', sortable: false },
          { text: this.use_language.sum_total, align: 'right', value: 'totalPrice', sortable: false },
        ]
      },
      excel_detail_invoice_list_header () {
        if (this.use_language == null) return []
        return [
          { label: this.use_language.menu_orders, field: "orderID", width: 15},
          { label: this.use_language.track_number, field: "trackingNo", width: 25 },
          { label: this.use_language.creation_date, field: "createdDatetime", width: 25 },
          { label: this.use_language.pack_date, field: "packedDate", width: 25 },
          { label: this.use_language.transport, field: "expressCompanyName", width: 25 },
          { label: this.use_language.weight, field: "boxWeight", width: 15 },
          { label: this.use_language.cubic1, field: "boxWidth", width: 15 },
          { label: this.use_language.cubic2, field: "boxLong", width: 15 },
          { label: this.use_language.cubic3, field: "boxHigh", width: 15 },
          { label: this.use_language.reference_number, field: "referenceNo", width: 30 },
          { label: this.use_language.delivery_fee, field: "deliveryPrice", width: 15 },
          { label: this.use_language.remote_area_fee, field: "remotePrice",  width: 15 },
          { label: this.use_language.cod_value, field: "codPrice", width: 15 },
          { label: this.use_language.box_fee, field: 'boxPrice', width: 15 },
          { label: this.use_language.pack_fee, field: "packPrice", width: 15 },
          { label:  this.use_language.bubble_fee, field: "bubblePrice", width: 15 },
          { label: this.use_language.discount, field: "discount", width: 15},
          { label: this.use_language.vrich_connection_fee, field: "vrichFee", width: 15},
          { label: this.use_language.other_fee, field: "otherServicePrice", width: 15},
          { label: this.use_language.total_price, field: "totalPrice", width: 15},
        ]
      },
    },
    async created() {

       //เก็บภาษามาไว้ใน use_language
         this.use_language = await this.get_languages(localStorage.getItem("set_language"));


      this.inv = null
      this.inv_group = null
      if(this.$route.query.inv === 'undefined'){
        this.inv = null
      } else if ( this.$route.query.inv == 'null') {
        this.inv = null
      } else if ( this.$route.query.inv == null) {
        this.inv = null
      } else if (this.$route.query.inv == '') {
        this.inv = null
      } else {
        this.inv = this.$route.query.inv
      }


      if(this.$route.query.group === 'undefined'){
        this.inv_group = null
      } else if ( this.$route.query.group == 'null') {
        this.inv_group = null
      } else if ( this.$route.query.group == null) {
        this.inv_group = null
      } else if (this.$route.query.group == '') {
        this.inv_group = null
      } else {
        this.inv_group = this.$route.query.group
      }


      await this.get_invoice(true)
      // await this.get_invoice()
      this.page_loading = false

    },
    methods: {
      format_number, format_order_id, format_price, FormatInvoice,get_languages,
      detail_page (id) {
        window.open('order-detail?id='+id, '_blank');
      },
      async get_invoice (type) {
        this.loading = true
        if (type == true) {
          this.offsets = 0;
          this.page = 1;
          if(this.inv_group != null) {
            let res = await axios.post(reportService_dotnet+'Invoice/get-invoice-befor-delete-invoice', {
              "invoiceID": this.inv == null ? 0 : this.inv,
              "invoiceGroupID": this.inv_group
            },
            { headers: header_token})
            var invopice_title = ''

            if(res.data.length > 0){
              for (var i = 0; i < res.data.length; i++) {

                if(i == res.data.length -1) {
                  invopice_title += res.data[i]
                } else {
                  invopice_title += res.data[i] + ', '
                }
              }
            }

            this.sh_invoiceNo = invopice_title
            // this.sh_invoiceDate = row.invoiceDate
          } else {
            this.sh_invoiceNo = null
          }
        }

        if( this.inv_group != null){
          let res1 = await axios.post(reportService_dotnet+'Invoice/group-detail1', {
            "id": this.inv_group,
            "limits": this.limits,
            "offsets": this.offsets,
            "isNeedSum": this.isNeedSum
          },
          { headers: header_token})
          if(res1.data == ''){
            this.datalist = []
            // this.datalist_for_excel = []
          } else {

            if(res1.data.status == 'error'){
              this.datalist = []
              // this.datalist_for_excel = []
              await this.$swal({
                  position: "top",
                  type: "info",
                  text: this.use_language.invoice_not_found,
              })
              this.loading = false
              return
            } else {
              this.datalist = []
              this.datalist = res1.data.itemList
              // this.datalist_for_excel = [...res1.data.itemList]
            }

          }

          this.item_invoice_list = res1.data.itemListGroupIsNull
          this.ch_InvoiceGroupID = res1.data.invoiceGroupID

          if (this.isNeedSum) {
            this.data_group_detail = res1.data
            this.totalRows = res1.data.totalRows
          }

          // this.datalist_for_excel.push({"vrichFee": "ค่าขนส่ง" , "totalPrice": this.data_group_detail.deliveryPrice})
          // this.datalist_for_excel.push({"vrichFee": "ค่าบริการ COD" , "totalPrice": this.data_group_detail.codCharged})
          // this.datalist_for_excel.push({"vrichFee": "ภาษีมูลค่าเพิ่ม" , "totalPrice": this.data_group_detail.codVatAmount})
          // this.datalist_for_excel.push({"vrichFee": "ค่าบริการอื่นๆ" , "totalPrice": this.data_group_detail.servicePrice})
          // this.datalist_for_excel.push({"vrichFee": "ภาษีมูลค่าเพิ่ม" , "totalPrice": this.data_group_detail.serviceVatAmount})
          // this.datalist_for_excel.push({"vrichFee": "ส่วนลด" , "totalPrice": this.data_group_detail.discount})
          // this.datalist_for_excel.push({"vrichFee": "รวมยอดทั้งหมด" , "totalPrice": this.data_group_detail.totalPrice})

          this.pageLength =  (Math.ceil(this.totalRows/this.limits))
          if (this.pageLength <= 0) {
            this.pageLength = 1
          }

        } else {
          let res2 = await axios.post(reportService_dotnet+'Invoice/group-detail', {
            "id": this.inv,
            "limits": this.limits,
            "offsets": this.offsets,
            "isNeedSum": this.isNeedSum
          },
          { headers: header_token})
          if(res2.data == ''){
            this.datalist = []
            // this.datalist_for_excel = []
          } else {
            this.datalist = []
            // this.datalist_for_excel = []
            this.datalist = res2.data.itemList
            // this.datalist_for_excel = [...res2.data.itemListGroupIsNull]
          }
          this.item_invoice_list = res2.data.itemListGroupIsNull
          this.ch_InvoiceGroupID = res2.data.invoiceGroupID

          if (this.isNeedSum) {
            this.data_group_detail = res2.data
            this.totalRows = res2.data.totalRows
          }

          this.pageLength =  (Math.ceil(this.totalRows/this.limits))
          if (this.pageLength <= 0) {
            this.pageLength = 1
          }

          // this.datalist_for_excel.push({"discount": "ค่าขนส่ง" , "totalPrice": this.data_group_detail.deliveryPrice})
          // this.datalist_for_excel.push({"discount": "ค่าบริการ COD" , "totalPrice": this.data_group_detail.codCharged})
          // this.datalist_for_excel.push({"discount": "ภาษีมูลค่าเพิ่ม" , "totalPrice": this.data_group_detail.codVatAmount})
          // this.datalist_for_excel.push({"discount": "ค่าบริการอื่นๆ" , "totalPrice": this.data_group_detail.servicePrice})
          // this.datalist_for_excel.push({"discount": "ภาษีมูลค่าเพิ่ม" , "totalPrice": this.data_group_detail.serviceVatAmount})
          // this.datalist_for_excel.push({"discount": "รวมยอดทั้งหมด" , "totalPrice": this.data_group_detail.totalPrice})
        }
        this.isNeedSum = false
        this.loading = false
      },

      async changePage() {
        this.offsets = (this.page * this.limits) - this.limits
        if (this.page > 1 && this.page < this.pageLength ) {
          if(this.page_tmp != this.page){
            await this.get_invoice()
            this.page_tmp = this.page
          }
        } else if (this.page == 1, this.pageLength) {
          if(this.page_tmp != this.page){
            await this.get_invoice()
            this.page_tmp = this.page
          }
        }
      },

      async LimitChange() {
        await this.get_invoice(true);
      },

      async getItemsForExcel(limits, offsets) {
        if (this.inv_group != null) {
          let res1 = await axios.post(
            reportService_dotnet+'Invoice/group-detail1',
            {
              "id": this.inv_group ,
              "limits": limits,
              "offsets": offsets,
              "isNeedSum": false
            },
            { headers: header_token}
          )
          return res1.data
        } else {
          let res1 = await axios.post(
            reportService_dotnet+'Invoice/group-detail',
            {
              "id": this.inv,
              "limits": limits,
              "offsets": offsets,
              "isNeedSum": false
            },
            { headers: header_token}
          )
          return res1.data
        }
      },

      async ExportExcel() {
        this.datalist_for_excel = []
        this.loadingExcel = 0;
        Swal.fire({
          type: "warning",
          text: this.use_language.warning_wait_excel,
          confirmButtonText: this.use_language.confirm,
          cancelButtonText: this.use_language.cancel,
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          allowOutsideClick: false,
        }).then(async (result) => {
          if (result.value) {
            var limits = 500;
            var offsets = 0;
            this.loadingExcel = 1;
            var total = this.totalRows;
            var round = parseInt(total / limits);

            if (limits * round < total) {
              round = round + 1;
            }

            var no = 0;
            for (var i = 1; i <= round; i++) {
              var resultData = await this.getItemsForExcel(limits, offsets);
              this.datalist_for_excel.push(...resultData.itemList);
              this.loadingExcel = parseInt(
                (parseFloat(i) / parseFloat(round)) * parseFloat(100)
              );
              offsets = offsets + limits;
            }

            this.datalist_for_excel.push({"vrichFee": this.use_language.freight , "totalPrice": this.data_group_detail.deliveryPrice})
            this.datalist_for_excel.push({"vrichFee": this.use_language.cod_service_fee , "totalPrice": this.data_group_detail.codCharged})
            this.datalist_for_excel.push({"vrichFee": this.use_language.vat , "totalPrice": this.data_group_detail.codVatAmount})
            this.datalist_for_excel.push({"vrichFee": this.use_language.other_service_charges , "totalPrice": this.data_group_detail.servicePrice})
            this.datalist_for_excel.push({"vrichFee": this.use_language.vat , "totalPrice": this.data_group_detail.serviceVatAmount})
            this.datalist_for_excel.push({"vrichFee": this.use_language.total_amount_ , "totalPrice": this.data_group_detail.totalPrice})

            this.loadingExcel = this.datalist_for_excel.length == 0 ? 0 : 100;
            document.getElementById("GetExcel").click();
          }
        });
      },

    }
  }
</script>
<style>
  .packhai-border-table{
    /* border:1px solid #e9edf4; */
    border-collapse: collapse;
    border-spacing: 0px;
    border-right: 1px solid #e9edf4;
    border-bottom: 1px solid #e9edf4;
    border-top: 1px solid #e9edf4;
  }
  .packhai-border-table thead{
    color:white;
  }
  .packhai-border-table thead tr th{
    color: black !important;
    font-weight: bold;
    font-size: 14px;
  }
  .packhai-border-table tr {
    /* border-collapse: collapse; */
    /* border: 1px solid #e9edf4; */
  }
  .packhai-border-table th {
    /* border-collapse: collapse; */
      border-left: 1px solid #e9edf4;
  }
  .packhai-border-table tr td{
    border-left: 1px solid #e9edf4;
  }


</style>
